import type { TOption } from './types';

export const uniqueOptions = (options: TOption[]): TOption[] => {
  const values = new Set<string | number>();

  return options.filter((option) => {
    if (values.has(option.value)) {
      return false;
    }

    values.add(option.value);
    return true;
  });
};

export const isColumnsOrderModelEqual = (left: string[] | undefined, right: string[]): boolean => {
  return (left?.length ?? 0) === right.length && right.every((field, index) => left?.[index] === field);
};
